module.exports = __webpack_public_path__ + "static/predefine_template_3-3f867bbf8b137e0e129b974c739ac276.png";